import {useInitialLocation} from './context';

export const SRT_PARAM = 'srt' as const;

export function useSrtParam() {
  const {search} = useInitialLocation();
  const originalParams = new URLSearchParams(search);

  return originalParams.get(SRT_PARAM);
}
